function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Swiper from 'swiper/bundle';
function initializeSwiper() {
  // swiper menu header
  var swiperMenuDesktop = new Swiper('.menu-desktop .swiper', {
    slidesPerView: 3.2,
    spaceBetween: 20,
    keyboard: {
      enabled: true,
      onlyInViewport: false
    },
    mousewheel: {
      enabled: true,
      sensitivity: 4
    },
    scrollbar: {
      el: '.menu-desktop .swiper-scrollbar',
      draggable: true,
      dragSize: '415px'
    }
  });

  // swiper header sitelock

  var swiperSitelock = new Swiper('.swiper-header-sitelock', {
    slidesPerView: 3.2,
    spaceBetween: 20,
    keyboard: {
      enabled: true,
      onlyInViewport: false
    },
    mousewheel: {
      enabled: true,
      sensitivity: 4
    }
  });

  // swiper page puma
  var swiperPuma = new Swiper('.swiper-puma', {
    slidesPerView: 1,
    autoHeight: true,
    calculateHeight: true,
    speed: 800,
    autoplay: {
      delay: 3000
    }
  });
  var swiper = new Swiper(".swiper_slider", {
    slidesPerView: 2,
    spaceBetween: 30,
    freeMode: true,
    mousewheel: {
      forceToAxis: true
    },
    breakpoints: {
      640: {
        slidesPerView: 2
      },
      768: {
        slidesPerView: 3
      },
      1024: {
        slidesPerView: 4
      }
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    }
  });
  var swiperCards = new Swiper(".swiper_slider_layout", _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
    slidesPerView: 2,
    freeMode: true,
    mousewheel: true,
    mousewheelControl: true
  }, "freeMode", true), "followFinger", true), "loop", true), "autoplay", {
    delay: 2500,
    disableOnInteraction: false
  }), "breakpoints", {
    640: {
      slidesPerView: 2
    },
    768: {
      slidesPerView: 3
    },
    1024: {
      slidesPerView: 4
    }
  }), "navigation", {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  }));
  var swiperProduct = new Swiper(".swiper_carrousel_layout", {
    slidesPerView: 2,
    freeMode: true,
    followFinger: true,
    loop: true,
    mousewheel: {
      forceToAxis: true,
      mousewheelControl: true
    },
    breakpoints: {
      640: {
        slidesPerView: 2
      },
      768: {
        slidesPerView: 3
      },
      1024: {
        slidesPerView: 4
      }
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    }
  });
  var swiperArticle = new Swiper('.swiper-article-lookbook', {
    slidesPerView: "auto",
    centeredSlides: true,
    spaceBetween: 15,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    }
  });
  return {
    swiperSitelock: swiperSitelock,
    swiperPuma: swiperPuma,
    swiperArticle: swiperArticle,
    swiperMenuDesktop: swiperMenuDesktop,
    swiperCards: swiperCards
  };
}
export default initializeSwiper;